module.exports = __webpack_public_path__ + "static/media/bell-on.6d195bd2.svg";